import styled from 'styled-components';

import { HeadlineL } from '@sorare/core/src/atoms/typography';
import { StrokedText } from '@sorare/core/src/atoms/typography/StrokedText';
import { useSnackNotificationContext } from '@sorare/core/src/contexts/snackNotification';
import { useCopyToClipboard } from '@sorare/core/src/hooks/useCopyToClipboard';

import { BrandedPlayButton } from 'components/rivals/BrandedPlayButton';
import { BrandedPlayButtonStatus } from 'components/rivals/BrandedPlayButton/types';

const CodeTypography = styled(HeadlineL).attrs({ as: 'span' })`
  text-transform: uppercase;
  letter-spacing: 0.5ch;
`;

type Props = { joinSecret: string };
export const BrandedInviteCodeButton = ({ joinSecret }: Props) => {
  const { showNotification } = useSnackNotificationContext();
  const copyToClipboard = useCopyToClipboard();
  const onCopyCode = () => {
    copyToClipboard(joinSecret);
    showNotification('copiedToClipboard');
  };

  return (
    <BrandedPlayButton
      status={BrandedPlayButtonStatus.GREEN}
      onClick={onCopyCode}
    >
      <CodeTypography>
        <StrokedText strokeWidth={2} yOffset={2}>
          {joinSecret}
        </StrokedText>
      </CodeTypography>
    </BrandedPlayButton>
  );
};
